import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type WorkforcePermissionsEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const workforcePermissionsPageEntryPoint: EntryPoint<
	WorkforcePermissionsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<WorkforcePermissionsEntryPointComponent>(
		/* webpackChunkName: "async-project-settings-service-desk-workforce-permissions", jiraSpaEntry: "async-project-settings-service-desk-workforce-permissions" */ './WorkforcePermissionsPage.tsx',
	),
	// Data-free page boundary: RBAC permissions queries get preloaded here in a follow-up. Keeping
	// `queries` empty is what stops this route from paying for the workforce routing settings data.
	getPreloadProps: () => ({}),
});
